// test1944
(1944 && 0);
